import * as Yup from 'yup';

export function createSaleValidationSchema({
    showSecondPayment,
    totalPayment,
    isFieldRequired,
    isDeliverMandatory,
    isLoadingMandatory,
    otherTaxRequired,
    t,
}) {
    Yup.addMethod(Yup.string, "paymentAmountsLessThanTotal", function (errorMessage) {
        return this.test(`paymentAmountsLessThanTotal`, errorMessage, function (value, object) {
            const { path, createError } = this;
            const formValues = object.options.parent;
            let paymentAmount = formValues.paymentAmount;
            let paymentAmount2 = showSecondPayment ? formValues.paymentAmount2 : "";
            paymentAmount = paymentAmount === "" ? 0.0 : parseFloat(paymentAmount);
            paymentAmount2 = paymentAmount2 === "" ? 0.0 : parseFloat(paymentAmount2);
            const totalPaymentAmount = paymentAmount + paymentAmount2;
            const condition = value == null || value === "" || totalPaymentAmount <= totalPayment;
            return condition || createError({ path, message: errorMessage });
        });
    });

    return Yup.object().shape({
        customer: isFieldRequired("customer") ? Yup.object().typeError(t("fieldRequired")).required(t("fieldRequired")) : Yup.mixed().nullable(),
        correlativeSales: isFieldRequired("correlativeSales") ? Yup.object().typeError(t("fieldRequired")).required(t("fieldRequired")) : Yup.mixed().nullable(),
        branch: Yup.object().typeError(t("fieldRequired")).required(t("fieldRequired")),
        invoiceType: Yup.object().typeError(t("fieldRequired")).required(t("fieldRequired")),
        series: Yup.object().typeError(t("fieldRequired")).required(t("fieldRequired")),
        subjectField: Yup.string().nullable().max(150, t("maxLengthValidation", { maxlength: 150 })),
        invoiceDate: Yup.date().nullable().transform((curr, orig) => orig === '' ? null : curr).required(t("fieldRequired")),
        taxpayerId: isFieldRequired("taxpayerId") ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        city: isFieldRequired("city") ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        country: isFieldRequired("country") ? Yup.object().typeError(t("fieldRequired")).required(t("fieldRequired")) : Yup.mixed().nullable(),
        fulladdress: isFieldRequired("fulladdress") ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        addressNumber: isFieldRequired("addressNumber") ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        postalCode: isFieldRequired("postalCode") ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        otherTaxCategory: otherTaxRequired ? Yup.object().typeError(t("fieldRequired")).required(t("fieldRequired")) : Yup.mixed().nullable(),
        otherTaxAmount: otherTaxRequired ? Yup.string().required(t("fieldRequired")) : Yup.string(),
        deliveryAddressStreet: isDeliverMandatory ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        deliveryAddressCity: isDeliverMandatory ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        deliveryAddressNumber: isDeliverMandatory ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        deliveryAddressPostalCode: isDeliverMandatory ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        loadingAddressStreet: isLoadingMandatory ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        loadingAddressCity: isLoadingMandatory ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        loadingAddressNumber: isLoadingMandatory ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        loadingAddressPostalCode: isLoadingMandatory ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
        movePurpose: isDeliverMandatory ? Yup.object().typeError(t("fieldRequired")).required(t("fieldRequired")) : Yup.mixed().nullable(),
        paymentAmount: Yup.string().paymentAmountsLessThanTotal(t("paymentLessThanInvoiceAmount")).nullable(),
        paymentAmount2: Yup.string().paymentAmountsLessThanTotal(t("paymentLessThanInvoiceAmount")).nullable(),
        otherMovePurposeTitle: isFieldRequired("otherMovePurposeTitle") ? Yup.string().required(t("fieldRequired")) : Yup.string().nullable(),
    });
}
